var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconquery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D0D3DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 14.0332C11.4976 14.0332 11.0865 13.6389 11.0657 13.1393L11.0116 11.8415C10.9973 11.4969 11.2727 11.2097 11.6176 11.2097C11.8627 11.2097 12.0735 11.1656 12.25 11.0774C12.4363 10.9891 12.5784 10.8666 12.6765 10.7097C12.7843 10.543 12.8382 10.347 12.8382 10.1215C12.8382 9.90579 12.7892 9.71952 12.6912 9.56265C12.5931 9.39599 12.4559 9.27344 12.2794 9.19501C12.1029 9.10677 11.8971 9.06265 11.6618 9.06265C11.299 9.06265 10.9657 9.1705 10.6618 9.38618C10.199 9.71015 9.53079 9.85387 9.11891 9.4672L9.02046 9.37478C8.71206 9.08526 8.62115 8.61719 8.88432 8.28602C9.13065 7.97606 9.42901 7.71043 9.77941 7.48912C10.3382 7.12638 11 6.94501 11.7647 6.94501C12.402 6.94501 12.9657 7.07736 13.4559 7.34207C13.9461 7.60677 14.3284 7.96952 14.6029 8.4303C14.8775 8.88128 15.0147 9.39109 15.0147 9.95971C15.0147 10.5381 14.8971 11.0332 14.6618 11.445C14.4265 11.8568 14.1078 12.195 13.7059 12.4597C13.4319 12.6334 13.1329 12.773 12.8089 12.8784C12.6494 12.9303 12.532 12.7497 12.6338 12.6164C12.7426 12.4736 12.9705 12.5596 12.958 12.7386L12.8965 13.6191C12.8803 13.8523 12.6863 14.0332 12.4525 14.0332H11.9977ZM11.9853 17.945C11.5931 17.945 11.2696 17.8127 11.0147 17.5479C10.7696 17.2832 10.6471 16.9646 10.6471 16.5921C10.6471 16.1999 10.7696 15.8764 11.0147 15.6215C11.2696 15.3568 11.5931 15.2244 11.9853 15.2244C12.3676 15.2244 12.6814 15.3568 12.9265 15.6215C13.1814 15.8764 13.3088 16.1999 13.3088 16.5921C13.3088 16.9646 13.1814 17.2832 12.9265 17.5479C12.6814 17.8127 12.3676 17.945 11.9853 17.945Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconquery);
export default __webpack_public_path__ + "static/media/Icon.query.dc20642680dd82184deb3d0ea0bc5732.svg";
export { ForwardRef as ReactComponent };